import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Certificate02 = function Certificate02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 18.5h6M7 15h10M5 2h14c1.1046 0 2 .995 2 2.2222v15.5556C21 21.0051 20.1046 22 19 22H5c-1.1046 0-2-.9949-2-2.2222V4.2222C3 2.995 3.8954 2 5 2m6.9976 4.212c-.6998-.7792-1.8667-.9888-2.7435-.2753S8.254 7.843 8.9425 8.6868 11.9976 11.5 11.9976 11.5s2.3666-1.9694 3.0551-2.8132c.6886-.8438.5802-2.0442-.3116-2.7501s-2.0437-.5039-2.7435.2752"
    })
  }));
};
export default Certificate02;